import React from 'react';
import PropTypes from 'prop-types';
import cuid from 'cuid';
import { css } from 'react-emotion';

const propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};

const disabledClass = css`
  opacity: 0.5;
  cursor: not-allowed;
  .slider,
  .slider::before {
    cursor: not-allowed;
  }
`;

class Switch extends React.PureComponent {
  constructor() {
    super();
    this.id = cuid();
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange({ target }) {
    const { onChange, disabled } = this.props;
    if(disabled === true) return;
    onChange({ [target.name]: target.checked });
  }

  render() {
    const { onChange, label, value, disabled, ...rest } = this.props;
    const wrapperClass = disabled === true ? disabledClass : '';
    return (
      <div className={`t-switch ${wrapperClass}`}>
        <span className="switch-label">{label}</span>
        <label className="switch" htmlFor={this.id}>
          <input type="checkbox" id={this.id} onChange={this.handleChange} checked={value} {...rest} />
          <div className="slider round" />
        </label>
      </div>
    );
  }
}

Switch.propTypes = propTypes;
export default Switch;


// WEBPACK FOOTER //
// ./src/components/form/Switch.jsx